import { Breadcrumb, BreadcrumbItem } from 'carbon-components-react'
import React, { useEffect } from 'react'
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;

const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const Dashboard = () => {

  useEffect(() => {
    document.title = "Dashboard | WillowBMS"
  }, [])

  return (
    <div id="body" className="bms-page d-flex">
      <div className="wrapper">
        <Breadcrumb>
          <BreadcrumbItem href="/">Dashboard</BreadcrumbItem>
        </Breadcrumb>
        <h2>
          Overview
        </h2>

      </div>
    </div>
  )
}

export default Dashboard